/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Financier } from './Financier';
import type { FinancierShopsGroup } from './FinancierShopsGroup';
import type { InstallmentNote } from './InstallmentNote';
import type { InstallmentPaymentDto } from './InstallmentPaymentDto';
import type { InstallmentPlanDocumentDto } from './InstallmentPlanDocumentDto';
import type { InstallmentShopDto } from './InstallmentShopDto';
import type { InstallmentTerm } from './InstallmentTerm';
import type { ProductDto } from './ProductDto';
import type { ProfileDto } from './ProfileDto';
export type InstallmentPlanSearchLoansRegisterDto = {
    creationToken?: string;
    id?: string;
    transactionId?: string;
    shopId: string;
    profile: ProfileDto;
    product: ProductDto;
    registrationDate?: string;
    registrationStatus?: InstallmentPlanSearchLoansRegisterDto.registrationStatus;
    lastRegistrationStatus?: InstallmentPlanSearchLoansRegisterDto.lastRegistrationStatus;
    registrationRejectReason?: string;
    sequenceNumber?: number;
    referenceId?: string;
    status?: InstallmentPlanSearchLoansRegisterDto.status;
    fundSource: InstallmentPlanSearchLoansRegisterDto.fundSource;
    activeTermNumber?: number;
    activeTermDueDate?: string;
    activeInstallmentPaymentId?: string;
    activeInstallmentPaymentAmount?: number;
    activeInstallmentPaymentDate?: string;
    commissionAmount?: number;
    totalAmount?: number;
    downPaymentPercent?: number;
    downPaymentAmount: number;
    downPaymentChannelId?: string;
    downPaymentDate: string;
    installmentTotalAmount?: number;
    installmentCount: number;
    installmentAmount: number;
    installmentStartDate: string;
    installmentFrequency: number;
    installmentFrequencyType: InstallmentPlanSearchLoansRegisterDto.installmentFrequencyType;
    otherCostAmount?: number;
    notes?: Array<InstallmentNote>;
    note?: string;
    documents?: Array<InstallmentPlanDocumentDto>;
    installmentTerms?: Array<InstallmentTerm>;
    payments?: Array<InstallmentPaymentDto>;
    activeDueDateDiff?: number;
    appointmentDateDiff?: number;
    createdByUserId?: string;
    createdByUserName?: string;
    createdByLastName?: string;
    createdAt?: string;
    updatedAt?: string;
    financierId?: string;
    additionalCommissionAmount?: number;
    financeCommissionPercent?: number;
    shopAgentCommissionPercent?: number;
    contractFeeAmount?: number;
    fineFeeAmount?: number;
    unlockingFeeAmount?: number;
    interestRate?: number;
    documentFeeAmount?: number;
    loanBalance?: number;
    completedAt?: string;
    isFirstPaidPayment?: boolean;
    shopAgentCommissionAmount?: number;
    shopCommissionAmount?: number;
    financier?: Financier;
    financierShopsGroup?: FinancierShopsGroup;
    shop?: InstallmentShopDto;
    installmentStatus?: InstallmentPlanSearchLoansRegisterDto.installmentStatus;
    approvedByUserId?: string;
    approvedAt?: string;
    refinancing?: string;
    refinancedBy?: string;
    valid?: boolean;
};
export namespace InstallmentPlanSearchLoansRegisterDto {
    export enum registrationStatus {
        PENDING_CUSTOMER_INFO = 'PENDING_CUSTOMER_INFO',
        PENDING_CUSTOMER_DOCUMENTS = 'PENDING_CUSTOMER_DOCUMENTS',
        PENDING_LOAN_AND_DEVICE_INFO = 'PENDING_LOAN_AND_DEVICE_INFO',
        PENDING_APPROVAL = 'PENDING_APPROVAL',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
        COMPLETED = 'COMPLETED',
        CANCEL = 'CANCEL',
    }
    export enum lastRegistrationStatus {
        PENDING_CUSTOMER_INFO = 'PENDING_CUSTOMER_INFO',
        PENDING_CUSTOMER_DOCUMENTS = 'PENDING_CUSTOMER_DOCUMENTS',
        PENDING_LOAN_AND_DEVICE_INFO = 'PENDING_LOAN_AND_DEVICE_INFO',
        PENDING_APPROVAL = 'PENDING_APPROVAL',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
        COMPLETED = 'COMPLETED',
        CANCEL = 'CANCEL',
    }
    export enum status {
        DRAFT = 'DRAFT',
        PENDING_CONTRACT_DOCUMENTS = 'PENDING_CONTRACT_DOCUMENTS',
        PENDING_CONFIRM_DOWN_PAYMENT = 'PENDING_CONFIRM_DOWN_PAYMENT',
        NORMAL = 'NORMAL',
        CLOSED = 'CLOSED',
        REFUND = 'REFUND',
        FOLLOWING_UP = 'FOLLOWING_UP',
        CANNOT_CONTACT_CUSTOMER = 'CANNOT_CONTACT_CUSTOMER',
        NON_PERFORMING = 'NON_PERFORMING',
        REPORTED = 'REPORTED',
        CANCEL = 'CANCEL',
        LOCKED = 'LOCKED',
        LOST = 'LOST',
        CLAIM = 'CLAIM',
    }
    export enum fundSource {
        SHOP = 'SHOP',
        FINANCE = 'FINANCE',
    }
    export enum installmentFrequencyType {
        DAY = 'DAY',
        MONTH = 'MONTH',
    }
    export enum installmentStatus {
        REGISTER = 'REGISTER',
        REJECTED = 'REJECTED',
        COMPLETED = 'COMPLETED',
    }
}

